import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row research-item" }
const _hoisted_2 = { class: "research-item-icon iodine-padding-right-md" }
const _hoisted_3 = { class: "col iodine-label research-item-label" }
const _hoisted_4 = ["innerHTML"]

import {ResearchItemDataModel} from 'components/resources/ResearchItemData.model';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ResearchItem',
  props: {
    researchItemDataModel: {}
  },
  setup(__props: any) {

  const props = __props;

  function openResearch(url: string) {

    if (url) {
      window.open(url, '_blank', 'width=1440,height=1024,left=0,top=0');
    }
  }


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_icon, {
        name: "fa-solid fa-circle",
        size: "6px",
        color: "primary"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", {
        class: "research-item-content",
        innerHTML: props.researchItemDataModel.text
      }, null, 8, _hoisted_4),
      _createElementVNode("span", null, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openResearch(props.researchItemDataModel.url)))
        }, _toDisplayString(props.researchItemDataModel.title), 1)
      ]),
      _withDirectives(_createElementVNode("span", null, " , ", 512), [
        [_vShow, props.researchItemDataModel.title !== '']
      ]),
      _withDirectives(_createElementVNode("span", { class: "research-item-subtitle" }, "  " + _toDisplayString(props.researchItemDataModel.subtitle), 513), [
        [_vShow, props.researchItemDataModel.subtitle !== '']
      ])
    ])
  ]))
}
}

})